import React from 'react'
import backArrow from "../../../assets/headerpage-icon/Arrow Down.svg";
import homeBanner from "../../../assets/headerpage-icon/homebanner.jpg";
import closeIcon from "../../../assets/headerpage-icon/close-icon.svg";
import heartFillIcon from "../../../assets/headerpage-icon/heart-fill.svg";
import heartOutlineIcon from "../../../assets/headerpage-icon/heart-outline.svg";

const ViewAllPhotos = () => {
    return (
        <>
            <div className="view-photos-section">
                <div className="view-head">
                    <div className="view-container">
                        <div className='back-section'>
                            <img src={backArrow} alt="" />
                            <span>BACK TO LISTING</span>
                        </div>
                    </div>
                </div>
                <div className="view-body">
                    <div className="view-container">
                        <div className="row">
                            <div className="col-xl-10 col-lg-9 col-md-7 col-12">
                                <div className="view-left-section">
                                    <div className="row g-3">
                                        <div className="col-md-12">
                                            <img src={homeBanner} className='img-fluid' alt="" />
                                        </div>
                                        <div className="col-md-6">
                                            <img src={homeBanner} className='img-fluid' alt="" />
                                        </div>
                                        <div className="col-md-6">
                                            <img src={homeBanner} className='img-fluid' alt="" />
                                        </div>
                                        <div className="col-md-12">
                                            <img src={homeBanner} className='img-fluid' alt="" />
                                        </div>
                                        <div className="col-md-6">
                                            <img src={homeBanner} className='img-fluid' alt="" />
                                        </div>
                                        <div className="col-md-6">
                                            <img src={homeBanner} className='img-fluid' alt="" />
                                        </div>
                                        <div className="col-md-12">
                                            <img src={homeBanner} className='img-fluid' alt="" />
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-xl-2 col-lg-3 col-md-5 col-12">
                                <div className="view-right-section">
                                    <div className="icon-panel">
                                        <span className="spancircle">
                                            <img src={closeIcon} />
                                        </span>
                                        <span className="spancircle addwishlist">
                                            <img src={heartOutlineIcon} className="heartIcon" alt="" />
                                        </span>
                                    </div>
                                    <div className="details-panel">
                                        <strong className='bold-price'>$569,000</strong>
                                        <div className="room-details">
                                            <div>
                                                <strong> 4</strong>
                                                <span>bed</span>
                                            </div>
                                            <div>
                                             <strong> 3</strong>
                                              <span>bath</span>
                                            </div>
                                            <div>
                                             <strong> 2308</strong>
                                              <span>sqft</span>
                                            </div>
                                        </div>
                                        <div className="address-details">
                                            <strong>1234 Main Street</strong>
                                            <span>Omaha, Nebraska 68134</span>
                                        </div>
                                        <button className='btn tour-btns'>Request Tour</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </>
    )
}

export default ViewAllPhotos